import { createAsyncThunk } from '@reduxjs/toolkit'
import { getFormTemplates, getFormTemplateById } from '@services/api/forms.api'
import type {
  IFormTemplate,
  ListFormTemplatesParams,
} from '@dataTypes/forms.type'

export const fetchFormTemplates = createAsyncThunk<
  IFormTemplate[],
  ListFormTemplatesParams | undefined
>('forms/fetchFormTemplates', async (params) => {
  const templates = await getFormTemplates(params)
  return templates
})

export const fetchFormTemplateById = createAsyncThunk<
  IFormTemplate | null,
  string
>('forms/fetchFormTemplateById', async (id: string) => {
  const template = await getFormTemplateById(id)
  return template
})
